
















































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {
  入庫保存依頼型,
  入庫入力型,
  入庫取込依頼型,
  入庫情報タブ入力型,
  入庫情報全指定バリデータマップ一覧,
  入庫確定依頼型,
  入庫納品データ検索条件型,
  入庫納品データ検索結果型,
  納品データ取込バリデータマップ一覧,
} from '@/type/stock/receive/unfixed';
import api from '@/infrastructure/api/api';
import {ValidationResult} from '@/type/validation/result';
import moment from 'moment';
import {progress} from '@/script/progress';
import {viewEditingStateModule} from '@/store/state/viewEditingState';

import UnfixedItemSearch from '@/views/stock/receive/UnfixedItemSearch.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import HandyImportDialog from '@/views/stock/receive/HandyStockImportDialog.vue';
import {HTデータ取込対象型} from '@/type/purchaseorder/item';
import StockReceiveWholesaleSelector from '@/views/stock/receive/StockReceiveWholesaleSelector.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import {マスタ選択区分型} from '@/type/wholesale/types';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import {loginModule} from '@/store/authentication/login';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import RegisterReceiveByOrderDialog from '@/views/stock/receive/RegisterReceiveByOrderDialog.vue';
import CodeInputDialog from '@/views/stock/receive/CodeInputDialog.vue';
import UnfixedStockDataRow from '@/views/stock/receive/fragments/UnfixedStockDataRow.vue';
import 入庫候補入力チェッカー from '@/type/stock/receive/入庫候補入力チェッカー';

@Component({
  components: {
    UnfixedItemSearch,
    Datepicker,
    ButtonPanel,
    IconButton,
    HandyImportDialog,
    StockReceiveWholesaleSelector,
    AlertDialog,
    ConfirmDialog,
    DepartmentSelector,
    NormalButton,
    RegisterReceiveByOrderDialog,
    CodeInputDialog,
    UnfixedStockDataRow,
  },
})
export default class UnfixedStock extends Vue {
  // data
  private itemModal: boolean = false;
  private handyModal: boolean = false;
  private codeModal: boolean = false;
  private 入庫取込結果: 入庫入力型[] = [];
  private 入庫削除対象行番号: number | null = null;
  private 選択中入庫先部署コード: string = loginModule.部署コードを取得する;
  private 入庫先部署コード: string = '';
  private 入庫情報タブ表示: boolean = false;
  private 納品情報タブ表示: boolean = false;
  private 入庫情報タブ入力: 入庫情報タブ入力型 = this.入庫情報タブ入力初期値();
  private 納品情報タブ入力: 入庫納品データ検索条件型 = this.入庫納品データ検索条件初期値();
  private 入庫取込依頼: 入庫取込依頼型 = this.入庫取込依頼初期値();

  // バリデーション用フィールド
  private HTデータ取込対象一覧: HTデータ取込対象型[] = [];

  private アラートメッセージ: string | string[] | null = null;

  private 納品データ卸マスタ選択区分: マスタ選択区分型 = マスタ選択区分型.採用品;
  private 選択中の行index: number | null = null;

  // computed
  get 表の高さのstyle() {
    let offset = 0;
    if (this.入庫情報タブ表示) offset = offset + 50;
    if (this.納品情報タブ表示) offset = offset + 50;
    offset = 350 + offset;
    return {
      height: `calc(100vh - ${offset}px)`,
    };
  }

  // watched property
  @Watch('入庫取込結果', {deep: true})
  入庫取込結果が変更された() {
    viewEditingStateModule.画面の編集を開始する();
  }

  // methods
  private 有効期限整合性チェック(入庫取込: 入庫入力型[]): string[] {
    const エラーメッセージ: string[] = [];
    入庫取込.forEach((入庫入力, 行番号) => {
      const moment有効期限 = moment(入庫入力.有効期限);
      const moment入庫日付 = moment(入庫入力.入庫日付);
      if (moment有効期限.isBefore(moment入庫日付)) {
        エラーメッセージ.push((行番号 + 1) + ': 有効期限が入庫日付より前の日付です');
      }
    });
    return エラーメッセージ;
  }

  private async 入庫取込ハンドラ(): Promise<void> {
    if (this.部署未確定()) {
      return;
    }
    await progress(this.入庫取込)
        .then((response: any) => {
          viewEditingStateModule.画面の編集を終了する();
        }).catch((error: any) => {
          return;
        });
  }

  private async 入庫取込(): Promise<void> {
    this.入庫取込依頼 = {
      部署コード: this.入庫先部署コード,
      登録者コード: this.利用ユーザーである() ? loginModule.利用者コードを取得する : '',
    };
    await api.未確定入庫を読み込む(this.入庫取込依頼)
        .then((response: 入庫入力型[]) => {
          this.入庫取込結果 = response;
          this.選択中の行index = null;
        }).catch((error: any) => {
          this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
          this.$modal.show('アラート');
          this.入庫取込結果 = [];
        });
  }

  private async 納品データ取込前ハンドラ(): Promise<void> {
    if (viewEditingStateModule.画面を編集中である) {
      this.ダイアログを開く('納品データ取込ダイアログ');
      return;
    }

    const 納品データ取込バリデーション結果: ValidationResult = new ValidationResult(納品データ取込バリデータマップ一覧);
    納品データ取込バリデーション結果.validate(this.納品情報タブ入力);
    if (納品データ取込バリデーション結果.hasErrors) {
      this.アラートメッセージ = 納品データ取込バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }

    await progress(this.納品データ取込)
        .then((response: any) => {
          viewEditingStateModule.画面の編集を終了する();
        }).catch((error: any) => {
          return;
        });
  }

  private async 納品データ取込ハンドラ(): Promise<void> {
    this.ダイアログを閉じる('納品データ取込ダイアログ');

    const 納品データ取込バリデーション結果: ValidationResult = new ValidationResult(納品データ取込バリデータマップ一覧);
    納品データ取込バリデーション結果.validate(this.納品情報タブ入力);
    if (納品データ取込バリデーション結果.hasErrors) {
      this.アラートメッセージ = 納品データ取込バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }

    await progress(this.納品データ取込)
        .then((response: any) => {
          viewEditingStateModule.画面の編集を終了する();
        }).catch((error: any) => {
          return;
        });
  }

  private async 納品データ取込(): Promise<void> {
    await api.入庫納品データを検索する(this.納品情報タブ入力)
        .then((response: 入庫納品データ検索結果型) => {
          this.入庫取込結果 = response.入庫入力一覧;
          if (this.入庫取込結果.length === 0) {
            this.アラートメッセージ = '取込対象の納品データが見つかりませんでした';
            this.$modal.show('アラート');
            return;
          }
          if (response.アラートメッセージ) {
            this.アラートメッセージ = response.アラートメッセージ;
            this.$modal.show('アラート');
          }
        }).catch((error: any) => {
          this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
          this.$modal.show('アラート');
        });
  }

  private async 全指定(): Promise<void> {
    if ((!this.入庫情報タブ入力.入庫伝票日付) && (!this.入庫情報タブ入力.入庫伝票番号)) {
      return;
    }
    const 入庫情報全指定バリデーション結果: ValidationResult = new ValidationResult(入庫情報全指定バリデータマップ一覧);
    入庫情報全指定バリデーション結果.validate(this.入庫情報タブ入力);
    if (入庫情報全指定バリデーション結果.hasErrors) {
      this.アラートメッセージ = 入庫情報全指定バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }

    this.入庫取込結果 = this.入庫取込結果.map((入庫入力) => {
      if (!this.編集不可(入庫入力)) {
        入庫入力.入庫日付 = this.入庫情報タブ入力.入庫伝票日付 ? this.入庫情報タブ入力.入庫伝票日付 : 入庫入力.入庫日付;
        入庫入力.伝票番号 = this.入庫情報タブ入力.入庫伝票番号 ? this.入庫情報タブ入力.入庫伝票番号 : 入庫入力.伝票番号;
      }
      return 入庫入力;
    });
  }

  private async 確定ハンドラ(): Promise<void> {
    const 入庫確定対象一覧 = this.入庫取込結果.filter((行) => 行.入庫確定区分 === '確定');
    if (入庫確定対象一覧.length < 1) {
      this.アラートメッセージ = '確定対象が存在しません';
      this.$modal.show('アラート');
      return;
    }
    const checker = new 入庫候補入力チェッカー();
    checker.validateList(this.入庫取込結果);
    if (checker.hasErrors()) {
      this.アラートメッセージ = checker.errorMessages();
      this.$modal.show('アラート');
      return;
    }
    await progress(this.新規確定);
  }

  private async 新規確定(): Promise<void> {
    const 入庫確定対象一覧 = this.入庫取込結果.filter((行) => 行.入庫確定区分 === '確定');
    const 入庫確定依頼: 入庫確定依頼型 = {入庫入力一覧: 入庫確定対象一覧, 入庫先部署: this.入庫先部署コード};
    await api.入庫を確定する(入庫確定依頼)
        .then((response: any) => {
          this.入庫取込結果 = [];
          this.入庫取込()
              .then((入庫取込response: any) => {
                viewEditingStateModule.画面の編集を終了する();
              }).catch((入庫取込error: any) => {
            return;
          });
        }).catch((error: any) => {
          this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
          this.$modal.show('アラート');
        });
  }

  private 検索ダイアログを開く(): void {
    this.itemModal = true;
  }

  private 商品追加ダイアログを閉じる(): void {
    this.itemModal = false;
  }

  private 発注指定入庫ダイアログを開く(): void {
    this.$modal.show('発注指定入庫登録ダイアログ');
  }

  private 発注指定入庫ダイアログを閉じる(): void {
    this.$modal.hide('発注指定入庫登録ダイアログ');
  }

  private コード入力ダイアログを開く() {
    this.codeModal = true;
  }

  private コード入力ダイアログを閉じる() {
    this.codeModal = false;
  }

  private selectItem(入庫入力一覧: 入庫入力型[]) {
    this.入庫取込結果 = this.入庫取込結果.concat(入庫入力一覧);
    this.itemModal = false;
  }

  private 編集不可(入庫入力: 入庫入力型): boolean {
    if (入庫入力.入力方法 === '納品データ') {
      return true;
    }
    return false;
  }

  private async 保存ハンドラ(): Promise<void> {
    const 入庫保存対象一覧 = this.入庫取込結果.filter((行) => 行.入庫確定区分 === '確定');
    if (入庫保存対象一覧.length < 1) {
      this.アラートメッセージ = '保存対象が存在しません';
      this.$modal.show('アラート');
      return;
    }
    const checker = new 入庫候補入力チェッカー();
    checker.validateList(this.入庫取込結果);
    if (checker.hasErrors()) {
      this.アラートメッセージ = checker.errorMessages();
      this.$modal.show('アラート');
      return;
    }
    await progress(this.保存);
  }

  private async 保存(): Promise<void> {
    const 入庫保存対象一覧 = this.入庫取込結果.filter((行) => 行.入庫確定区分 === '確定');
    const 入庫保存依頼: 入庫保存依頼型 = {入庫入力一覧: 入庫保存対象一覧, 入庫先部署: this.入庫先部署コード};
    await api.入庫を保存する(入庫保存依頼)
        .then((response: any) => {
          this.入庫取込()
              .then((入庫取込response: any) => {
                viewEditingStateModule.画面の編集を終了する();
              }).catch((入庫取込error: any) => {
            return;
          });
        }).catch((error: any) => {
          this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
          this.$modal.show('アラート');
        });
  }

  private HTデータ取込ダイアログを開く(): void {
    this.handyModal = true;
  }

  private HTデータ取込ダイアログを閉じる(): void {
    this.handyModal = false;
  }

  private addHandyItem(入庫入力一覧: 入庫入力型[]): void {
    this.入庫取込結果 = this.入庫取込結果.concat(入庫入力一覧);
    this.handyModal = false;
    // this.入庫取込();
  }

  private async getHandyList(): Promise<void> {
    const HTデータ取込対象取得結果 = await api.HTデータ取込対象一覧を取得する();
    this.HTデータ取込対象一覧 = HTデータ取込対象取得結果.ハンディデータ取込対象リスト;
    this.HTデータ取込対象一覧.push({機械番号: '', 端末名: '指定なし'});
  }

  private アラートダイアログを開く(event: Event): void {
    this.アラートメッセージ = event.toString().split(',');
    this.$modal.show('アラート');
  }

  private 行が選択されている(index: number): boolean {
    return this.選択中の行index === index;
  }

  private リスト選択時の処理(index: number): void {
    this.選択中の行index = index;
  }

  private 入庫の削除を確認する(event: any): void {
    this.入庫削除対象行番号 = event.rowIndex;
    this.ダイアログを開く('削除ダイアログ');
  }

  private async 入庫を削除するハンドラ(): Promise<void> {
    this.ダイアログを閉じる('削除ダイアログ');
    await progress(this.入庫を削除する)
        .then((入庫取込response: any) => {
          viewEditingStateModule.画面の編集を終了する();
        }).catch((入庫取込error: any) => {
          return;
        });
  }

  private async 入庫を削除する(): Promise<void> {
    const 入庫削除対象 = this.入庫取込結果.find((data, index) => index === this.入庫削除対象行番号);
    if (入庫削除対象 === undefined) {
      this.アラートメッセージ = '削除対象が選択されていません';
      this.$modal.show('アラート');
      return;
    }

    await api.未確定入庫を削除する(入庫削除対象)
        .then((response: any) => {
          this.入庫取込結果 = this.入庫取込結果.filter((data, index) => index !== this.入庫削除対象行番号);
          this.入庫削除対象行番号 = null;
        }).catch((error: any) => {
          this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
          this.$modal.show('アラート');
        });
  }

  private 削除ダイアログを閉じる(): void {
    this.入庫削除対象行番号 = null;
    this.ダイアログを閉じる('削除ダイアログ');
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private async クリアするハンドラ(): Promise<void> {
    await this.クリアする()
        .then((response: any) => {
          viewEditingStateModule.画面の編集を終了する();
        }).catch((error: any) => {
          return;
        });
  }

  private async クリアする(): Promise<void> {
    this.入庫取込結果 = [];
    this.入庫削除対象行番号 = null;
    this.選択中の行index = null;
    this.入庫情報タブ入力 = this.入庫情報タブ入力初期値();
    this.納品情報タブ入力 = this.入庫納品データ検索条件初期値();

    this.選択中入庫先部署コード = loginModule.部署コードを取得する;
    if (!this.利用ユーザーである()) {
      this.入庫先部署コード = '';
    }

    if (this.利用ユーザーである()) {
      this.入庫取込ハンドラ();
    }
    this.ダイアログを閉じる('クリアダイアログ');
  }

  private 部署を確定する(): void {
    if (this.選択中入庫先部署コード === null) {
      this.アラートメッセージ = '部署を選択してください';
      this.$modal.show('アラート');
      return;
    }
    this.入庫先部署コード = this.選択中入庫先部署コード;
    this.入庫取込ハンドラ();
  }

  private 利用ユーザーである(): boolean {
    return !loginModule.管理者である;
  }

  private 部署確定済(): boolean {
    return this.入庫先部署コード !== '';
  }

  private 部署未確定(): boolean {
    return !this.部署確定済();
  }

  private 納品データがある(): boolean {
    const 納品データ一覧 = this.入庫取込結果.filter((行) => 行.入力方法 === '納品データ');
    if (納品データ一覧.length > 0) {
      return true;
    }
    return false;
  }

  private APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    if (!data.errors) {
      return メッセージ;
    }

    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }

  private マスターである(): boolean {
    return loginModule.マスターである;
  }

  private 入庫情報タブの表示を切り替える(): void {
    this.入庫情報タブ表示 = !this.入庫情報タブ表示;
  }

  private 納品情報タブの表示を切り替える(): void {
    this.納品情報タブ表示 = !this.納品情報タブ表示;
  }

  private 入庫情報タブ入力初期値(): 入庫情報タブ入力型 {
    return {
      入庫伝票番号: '',
      入庫伝票日付: null,
    };
  }

  private 入庫納品データ検索条件初期値(): 入庫納品データ検索条件型 {
    return {
      伝票日付FROM: null,
      伝票日付TO: null,
      卸コード: '',
      卸伝票番号: '',
    };
  }

  private 入庫取込依頼初期値(): 入庫取込依頼型 {
    return {
      部署コード: '',
      登録者コード: '',
    };
  }

  // lifecycle hooks
  private mounted(): void {
    this.getHandyList();
    if (this.利用ユーザーである()) {
      this.部署を確定する();
    }
  }
}
